import type { SnapEventHandler, SnapEventMap, SnapEventName } from '../types';

export class SnapEventBus {
  private readonly handlers = new Map<SnapEventName, Set<SnapEventHandler<SnapEventName>>>();

  on<K extends SnapEventName>(event: K, handler: SnapEventHandler<K>): void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(handler as SnapEventHandler<SnapEventName>);
  }

  off<K extends SnapEventName>(event: K, handler: SnapEventHandler<K>): void {
    this.handlers.get(event)?.delete(handler as SnapEventHandler<SnapEventName>);
  }

  emit<K extends SnapEventName>(event: K, payload: SnapEventMap[K]): void {
    const set = this.handlers.get(event);
    if (!set) return;
    for (const handler of [...set]) {
      try {
        (handler as SnapEventHandler<K>)(payload);
      } catch {
        // Host callbacks must not break Snap lifecycle.
      }
    }
  }

  clear(): void {
    this.handlers.clear();
  }
}
